window.currentIndexes = window.currentIndexes || {};

window.moveSlide =
  window.moveSlide ||
  function (sectionId, step) {
    const mobile_slider = document.getElementById('mobile_slider-' + sectionId);
    const totalSlides = mobile_slider.children.length;

    if (!currentIndexes[sectionId]) currentIndexes[sectionId] = 0;

    currentIndexes[sectionId] = (currentIndexes[sectionId] + step + totalSlides) % totalSlides;
    mobile_slider.style.transform = `translateX(-${currentIndexes[sectionId] * 100}%)`;
  };
